module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/day01_03_stay-7136e0e012d55c67bfdeed30154f5afe.jpg";